module.exports = __webpack_public_path__ + "img/handraw_fleche orange.d8e9f091.svg";